
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/index.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-demo-quickstart"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/index.md?type=demo')
};